import { ErrorPage } from '@src/components'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import ContractWaitingLoader from './ContractWaitingLoader'

const ContractWaitingPage = () => {
  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation()

  if (!id) return <ErrorPage title={t('common.notFound')} />

  return <ContractWaitingLoader creditAppId={id} />
}

export default ContractWaitingPage
